import './App.css';
import { FooterPage } from 'pages/FooterPage';
import HeaderPage from 'pages/HeaderPage';
import { Toolbar } from '@mui/material';
import HomePage from 'pages/ContentPages/HomePage';
import { useState } from 'react';
import { AppProvider } from 'AppProvider';

function App() {
  const [contentPage, setContentPage] = useState(<HomePage />);

  return (
    // <>
    // <AppTestimonialsView title="my title" />
    // <AppCardView title="my title" description="my description" />
    // </>
    
    <AppProvider contentPage={contentPage} setContentPage={setContentPage}>
      <HeaderPage />
      <Toolbar />
      {contentPage}
      <FooterPage />
    </AppProvider>
  );
}

export default App;
